import { salesTypes } from "../types";

const initialState = {
    fetchingSalesOrderList: false,
    fetchSalesOrderListSuccess: null,
    fetchSalesOrderListFailure: null,
    creatingSalesOrder: false,
    createSalesOrderSuccess: null,
    createSalesOrderFailure: null,
    fetchingSingleSalesOrder: false,
    fetchSingleSalesOrderSuccess: null,
    fetchSingleSalesOrderFailure: null,
    fetchingSalesDashboardStats: false,
    fetchSalesDashboardStatsSuccess: null,
    fetchSalesDashboardStatsFailure: null,
    fetchingSalesTopAndLeastProducts: false,
    fetchSalesTopAndLeastProductsSuccess: null,
    fetchSalesTopAndLeastProductsFailure: null,
    fetchingSalesVelocityStat: false,
    fetchSalesVelocityStatSuccess: null,
    fetchSalesVelocityStatFailure: null,
    fetchingSalesChannelStat: false,
    fetchSalesChannelStatSuccess: null,
    fetchSalesChannelStatFailure: null,
    fetchingCustomerList: false,
    fetchCustomerListSuccess: null,
    fetchCustomerListFailure: null,
    fetchingSalesTopAndLeastRegions: false,
    fetchSalesTopAndLeastRegionsSuccess: null,
    fetchSalesTopAndLeastRegionsFailure: null,
    creatingSalesShipment: false,
    createSalesShipmentSuccess: null,
    createSalesShipmentFailure: null,
    updatingSalesOrder: false,
    updateSalesOrderSuccess: null,
    updateSalesOrderFailure: null,
    fetchingTopAndLeastSalesType: false,
    fetchTopAndLeastSalesTypeSuccess: null,
    fetchTopAndLeastSalesTypeFailure: null,
    fetchingTopAndLeastRetailsSales: false,
    fetchTopAndLeastRetailsSalesSuccess: null,
    fetchTopAndLeastRetailsSalesFailure: null,
    updatingMultipleSalesOrderStatus: false,
    updateMultipleSalesOrderStatusSuccess: null,
    updateMultipleSalesOrderStatusFailure: null,
    fetchingSalesSummary: false,
    fetchSalesSummarySuccess: null,
    fetchSalesSummaryFailure: null,
    deletingSalesOrder: false,
    deleteSalesOrderSuccess: null,
    deleteSalesOrderFailure: null,
    // Pin/Unpin functionality
    pinningSalesOrder: false,
    pinSalesOrderSuccess: null,
    pinSalesOrderFailure: null,
    unpinningSalesOrder: false,
    unpinSalesOrderSuccess: null,
    unpinSalesOrderFailure: null,
    bulkPinningSalesOrder: false,
    bulkPinSalesOrderSuccess: null,
    bulkPinSalesOrderFailure: null,
    bulkUnpinningSalesOrder: false,
    bulkUnpinSalesOrderSuccess: null,
    bulkUnpinSalesOrderFailure: null,
};

export const sales = (state = initialState, action: { type: string; payload: any }) => {
    switch (action.type) {
        case salesTypes.UPDATE_SALES_ORDER_REQUEST:
            return {
                ...state,
                updatingSalesOrder: true,
                updateSalesOrderSuccess: null,
                updateSalesOrderFailure: null,
            };
        case salesTypes.UPDATE_SALES_ORDER_SUCCESS:
            return {
                ...state,
                updatingSalesOrder: false,
                updateSalesOrderSuccess: action.payload,
                updateSalesOrderFailure: null,
            };
        case salesTypes.UPDATE_SALES_ORDER_FAILURE:
            return {
                ...state,
                updatingSalesOrder: false,
                updateSalesOrderSuccess: null,
                updateSalesOrderFailure: action.payload,
            };

        case salesTypes.FETCH_SALES_TOP_AND_LEAST_REGIONS_REQUEST:
            return {
                ...state,
                fetchingSalesTopAndLeastRegions: true,
                fetchSalesTopAndLeastRegionsSuccess: null,
                fetchSalesTopAndLeastRegionsFailure: null,
            };
        case salesTypes.FETCH_SALES_TOP_AND_LEAST_REGIONS_SUCCESS:
            return {
                ...state,
                fetchingSalesTopAndLeastRegions: false,
                fetchSalesTopAndLeastRegionsSuccess: action.payload,
                fetchSalesTopAndLeastRegionsFailure: null,
            };
        case salesTypes.FETCH_SALES_TOP_AND_LEAST_REGIONS_FAILURE:
            return {
                ...state,
                fetchingSalesTopAndLeastRegions: false,
                fetchSalesTopAndLeastRegionsSuccess: null,
                fetchSalesTopAndLeastRegionsFailure: action.payload,
            };

        case salesTypes.FETCH_CUSTOMER_LIST_REQUEST:
            return {
                ...state,
                fetchingCustomerList: true,
                fetchCustomerListSuccess: null,
                fetchCustomerListFailure: null,
            };
        case salesTypes.FETCH_CUSTOMER_LIST_SUCCESS:
            return {
                ...state,
                fetchingCustomerList: false,
                fetchCustomerListSuccess: action.payload,
                fetchCustomerListFailure: null,
            };
        case salesTypes.FETCH_CUSTOMER_LIST_FAILURE:
            return {
                ...state,
                fetchingCustomerList: false,
                fetchCustomerListSuccess: null,
                fetchCustomerListFailure: action.payload,
            };

        case salesTypes.FETCH_SALES_CHANNEL_STAT_REQUEST:
            return {
                ...state,
                fetchingSalesChannelStat: true,
                fetchSalesChannelStatSuccess: null,
                fetchSalesChannelStatFailure: null,
            };
        case salesTypes.FETCH_SALES_CHANNEL_STAT_SUCCESS:
            return {
                ...state,
                fetchingSalesChannelStat: false,
                fetchSalesChannelStatSuccess: action.payload,
                fetchSalesChannelStatFailure: null,
            };
        case salesTypes.FETCH_SALES_CHANNEL_STAT_FAILURE:
            return {
                ...state,
                fetchingSalesChannelStat: false,
                fetchSalesChannelStatSuccess: null,
                fetchSalesChannelStatFailure: action.payload,
            };

        case salesTypes.FETCH_SALES_VELOCITY_STAT_REQUEST:
            return {
                ...state,
                fetchingSalesVelocityStat: true,
                fetchSalesVelocityStatSuccess: null,
                fetchSalesVelocityStatFailure: null,
            };
        case salesTypes.FETCH_SALES_VELOCITY_STAT_SUCCESS:
            return {
                ...state,
                fetchingSalesVelocityStat: false,
                fetchSalesVelocityStatSuccess: action.payload,
                fetchSalesVelocityStatFailure: null,
            };
        case salesTypes.FETCH_SALES_VELOCITY_STAT_FAILURE:
            return {
                ...state,
                fetchingSalesVelocityStat: false,
                fetchSalesVelocityStatSuccess: null,
                fetchSalesVelocityStatFailure: action.payload,
            };

        case salesTypes.FETCH_SALES_TOP_AND_LEAST_PRODUCTS_REQUEST:
            return {
                ...state,
                fetchingSalesTopAndLeastProducts: true,
                fetchSalesTopAndLeastProductsSuccess: null,
                fetchSalesTopAndLeastProductsFailure: null,
            };
        case salesTypes.FETCH_SALES_TOP_AND_LEAST_PRODUCTS_SUCCESS:
            return {
                ...state,
                fetchingSalesTopAndLeastProducts: false,
                fetchSalesTopAndLeastProductsSuccess: action.payload,
                fetchSalesTopAndLeastProductsFailure: null,
            };
        case salesTypes.FETCH_SALES_TOP_AND_LEAST_PRODUCTS_FAILURE:
            return {
                ...state,
                fetchingSalesTopAndLeastProducts: false,
                fetchSalesTopAndLeastProductsSuccess: null,
                fetchSalesTopAndLeastProductsFailure: action.payload,
            };

        case salesTypes.FETCH_SALES_DASHBOARD_STATS_REQUEST:
            return {
                ...state,
                fetchingSalesDashboardStats: true,
                fetchSalesDashboardStatsSuccess: null,
                fetchSalesDashboardStatsFailure: null,
            };
        case salesTypes.FETCH_SALES_DASHBOARD_STATS_SUCCESS:
            return {
                ...state,
                fetchingSalesDashboardStats: false,
                fetchSalesDashboardStatsSuccess: action.payload,
                fetchSalesDashboardStatsFailure: null,
            };
        case salesTypes.FETCH_SALES_DASHBOARD_STATS_FAILURE:
            return {
                ...state,
                fetchingSalesDashboardStats: false,
                fetchSalesDashboardStatsSuccess: null,
                fetchSalesDashboardStatsFailure: action.payload,
            };

        case salesTypes.FETCH_SALES_ORDER_LIST_REQUEST:
            return {
                ...state,
                fetchingSalesOrderList: true,
                fetchSalesOrderListSuccess: null,
                fetchSalesOrderListFailure: null,
            };
        case salesTypes.FETCH_SALES_ORDER_LIST_SUCCESS:
            return {
                ...state,
                fetchingSalesOrderList: false,
                fetchSalesOrderListSuccess: action.payload,
                fetchSalesOrderListFailure: null,
            };
        case salesTypes.FETCH_SALES_ORDER_LIST_FAILURE:
            return {
                ...state,
                fetchingSalesOrderList: false,
                fetchSalesOrderListSuccess: null,
                fetchSalesOrderListFailure: action.payload,
            };

        case salesTypes.CREATE_SALES_ORDER_REQUEST:
            return {
                ...state,
                creatingSalesOrder: true,
                createSalesOrderSuccess: null,
                createSalesOrderFailure: null,
            };
        case salesTypes.CREATE_SALES_ORDER_SUCCESS:
            return {
                ...state,
                creatingSalesOrder: false,
                createSalesOrderSuccess: action.payload,
                createSalesOrderFailure: null,
            };
        case salesTypes.CREATE_SALES_ORDER_FAILURE:
            return {
                ...state,
                creatingSalesOrder: false,
                createSalesOrderSuccess: null,
                createSalesOrderFailure: action.payload,
            };

        case salesTypes.FETCH_SINGLE_SALES_ORDER_REQUEST:
            return {
                ...state,
                fetchingSingleSalesOrder: true,
                fetchSingleSalesOrderSuccess: null,
                fetchSingleSalesOrderFailure: null,
            };
        case salesTypes.FETCH_SINGLE_SALES_ORDER_SUCCESS:
            return {
                ...state,
                fetchingSingleSalesOrder: false,
                fetchSingleSalesOrderSuccess: action.payload,
                fetchSingleSalesOrderFailure: null,
            };
        case salesTypes.FETCH_SINGLE_SALES_ORDER_FAILURE:
            return {
                ...state,
                fetchingSingleSalesOrder: false,
                fetchSingleSalesOrderSuccess: null,
                fetchSingleSalesOrderFailure: action.payload,
            };
        case salesTypes.CREATE_SALES_SHIPMENT_REQUEST:
            return {
                ...state,
                creatingSalesShipment: true,
                createSalesShipmentSuccess: null,
                createSalesShipmentFailure: null,
            };
        case salesTypes.CREATE_SALES_SHIPMENT_SUCCESS:
            return {
                ...state,
                creatingSalesShipment: false,
                createSalesShipmentSuccess: action.payload,
                createSalesShipmentFailure: null,
            };
        case salesTypes.CREATE_SALES_SHIPMENT_FAILURE:
            return {
                ...state,
                creatingSalesShipment: false,
                createSalesShipmentSuccess: null,
                createSalesShipmentFailure: action.payload,
            };
        case salesTypes.FETCH_TOP_AND_LEAST_SALES_TYPE_REQUEST:
            return {
                ...state,
                fetchingTopAndLeastSalesType: true,
                fetchTopAndLeastSalesTypeSuccess: null,
                fetchTopAndLeastSalesTypeFailure: null,
            };
        case salesTypes.FETCH_TOP_AND_LEAST_SALES_TYPE_SUCCESS:
            return {
                ...state,
                fetchingTopAndLeastSalesType: false,
                fetchTopAndLeastSalesTypeSuccess: action.payload,
                fetchTopAndLeastSalesTypeFailure: null,
            };
        case salesTypes.FETCH_TOP_AND_LEAST_SALES_TYPE_FAILURE:
            return {
                ...state,
                fetchingTopAndLeastSalesType: false,
                fetchTopAndLeastSalesTypeSuccess: null,
                fetchTopAndLeastSalesTypeFailure: action.payload,
            };
        case salesTypes.FETCH_TOP_AND_LEAST_RETAILS_SALES_REQUEST:
            return {
                ...state,
                fetchingTopAndLeastRetailsSales: true,
                fetchTopAndLeastRetailsSalesSuccess: null,
                fetchTopAndLeastRetailsSalesFailure: null,
            };
        case salesTypes.FETCH_TOP_AND_LEAST_RETAILS_SALES_SUCCESS:
            return {
                ...state,
                fetchingTopAndLeastRetailsSales: false,
                fetchTopAndLeastRetailsSalesSuccess: action.payload,
                fetchTopAndLeastRetailsSalesFailure: null,
            };
        case salesTypes.FETCH_TOP_AND_LEAST_RETAILS_SALES_FAILURE:
            return {
                ...state,
                fetchingTopAndLeastRetailsSales: false,
                fetchTopAndLeastRetailsSalesSuccess: null,
                fetchTopAndLeastRetailsSalesFailure: action.payload,
            };
        case salesTypes.UPDATE_MULTIPLE_SALES_ORDER_STATUS_REQUEST:
            return {
                ...state,
                updatingMultipleSalesOrderStatus: true,
                updateMultipleSalesOrderStatusSuccess: null,
                updateMultipleSalesOrderStatusFailure: null,
            };
        case salesTypes.UPDATE_MULTIPLE_SALES_ORDER_STATUS_SUCCESS:
            return {
                ...state,
                updatingMultipleSalesOrderStatus: false,
                updateMultipleSalesOrderStatusSuccess: action.payload,
                updateMultipleSalesOrderStatusFailure: null,
            };
        case salesTypes.UPDATE_MULTIPLE_SALES_ORDER_STATUS_FAILURE:
            return {
                ...state,
                updatingMultipleSalesOrderStatus: false,
                updateMultipleSalesOrderStatusSuccess: null,
                updateMultipleSalesOrderStatusFailure: action.payload,
            };
        case salesTypes.FETCH_SALES_SUMMARY_REQUEST:
            return {
                ...state,
                fetchingSalesSummary: true,
                fetchSalesSummarySuccess: null,
                fetchSalesSummaryFailure: null,
            };
        case salesTypes.FETCH_SALES_SUMMARY_SUCCESS:
            return {
                ...state,
                fetchingSalesSummary: false,
                fetchSalesSummarySuccess: action.payload,
                fetchSalesSummaryFailure: null,
            };
        case salesTypes.FETCH_SALES_SUMMARY_FAILURE:
            return {
                ...state,
                fetchingSalesSummary: false,
                fetchSalesSummarySuccess: null,
                fetchSalesSummaryFailure: action.payload,
            };
        case salesTypes.DELETE_SALES_ORDER_REQUEST:
            return {
                ...state,
                deletingSalesOrder: true,
                deleteSalesOrderSuccess: null,
                deleteSalesOrderFailure: null,
            };
        case salesTypes.DELETE_SALES_ORDER_SUCCESS:
            return {
                ...state,
                deletingSalesOrder: false,
                deleteSalesOrderSuccess: action.payload,
                deleteSalesOrderFailure: null,
            };
        case salesTypes.DELETE_SALES_ORDER_FAILURE:
            return {
                ...state,
                deletingSalesOrder: false,
                deleteSalesOrderSuccess: null,
                deleteSalesOrderFailure: action.payload,
            };

        // Pin/Unpin functionality
        case salesTypes.PIN_SALES_ORDER_REQUEST:
            return {
                ...state,
                pinningSalesOrder: true,
                pinSalesOrderSuccess: null,
                pinSalesOrderFailure: null,
            };
        case salesTypes.PIN_SALES_ORDER_SUCCESS:
            return {
                ...state,
                pinningSalesOrder: false,
                pinSalesOrderSuccess: action.payload,
                pinSalesOrderFailure: null,
            };
        case salesTypes.PIN_SALES_ORDER_FAILURE:
            return {
                ...state,
                pinningSalesOrder: false,
                pinSalesOrderSuccess: null,
                pinSalesOrderFailure: action.payload,
            };

        case salesTypes.UNPIN_SALES_ORDER_REQUEST:
            return {
                ...state,
                unpinningSalesOrder: true,
                unpinSalesOrderSuccess: null,
                unpinSalesOrderFailure: null,
            };
        case salesTypes.UNPIN_SALES_ORDER_SUCCESS:
            return {
                ...state,
                unpinningSalesOrder: false,
                unpinSalesOrderSuccess: action.payload,
                unpinSalesOrderFailure: null,
            };
        case salesTypes.UNPIN_SALES_ORDER_FAILURE:
            return {
                ...state,
                unpinningSalesOrder: false,
                unpinSalesOrderSuccess: null,
                unpinSalesOrderFailure: action.payload,
            };

        case salesTypes.BULK_PIN_SALES_ORDER_REQUEST:
            return {
                ...state,
                bulkPinningSalesOrder: true,
                bulkPinSalesOrderSuccess: null,
                bulkPinSalesOrderFailure: null,
            };
        case salesTypes.BULK_PIN_SALES_ORDER_SUCCESS:
            return {
                ...state,
                bulkPinningSalesOrder: false,
                bulkPinSalesOrderSuccess: action.payload,
                bulkPinSalesOrderFailure: null,
            };
        case salesTypes.BULK_PIN_SALES_ORDER_FAILURE:
            return {
                ...state,
                bulkPinningSalesOrder: false,
                bulkPinSalesOrderSuccess: null,
                bulkPinSalesOrderFailure: action.payload,
            };

        case salesTypes.BULK_UNPIN_SALES_ORDER_REQUEST:
            return {
                ...state,
                bulkUnpinningSalesOrder: true,
                bulkUnpinSalesOrderSuccess: null,
                bulkUnpinSalesOrderFailure: null,
            };
        case salesTypes.BULK_UNPIN_SALES_ORDER_SUCCESS:
            return {
                ...state,
                bulkUnpinningSalesOrder: false,
                bulkUnpinSalesOrderSuccess: action.payload,
                bulkUnpinSalesOrderFailure: null,
            };
        case salesTypes.BULK_UNPIN_SALES_ORDER_FAILURE:
            return {
                ...state,
                bulkUnpinningSalesOrder: false,
                bulkUnpinSalesOrderSuccess: null,
                bulkUnpinSalesOrderFailure: action.payload,
            };

        // Reset action cases
        case salesTypes.RESET_PIN_SALES_ORDER_SUCCESS:
            return {
                ...state,
                pinSalesOrderSuccess: null,
            };
        case salesTypes.RESET_UNPIN_SALES_ORDER_SUCCESS:
            return {
                ...state,
                unpinSalesOrderSuccess: null,
            };
        case salesTypes.RESET_BULK_PIN_SALES_ORDER_SUCCESS:
            return {
                ...state,
                bulkPinSalesOrderSuccess: null,
            };
        case salesTypes.RESET_BULK_UNPIN_SALES_ORDER_SUCCESS:
            return {
                ...state,
                bulkUnpinSalesOrderSuccess: null,
            };

        default:
            return state;
    }
};
